const formatDate = (dateString) => {
  if (!dateString) return "Not Available";

  const date = new Date(dateString);
  if (isNaN(date)) return "Not Available";

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export default formatDate;
